<div
  [class.form-group]="(model.type !== 'GROUP' && asBootstrapFormGroup) || getClass('element', 'container').includes('form-group')"
  [class.d-none]="model.hidden"
  [formGroup]="group"
  [ngClass]="[getClass('element', 'container'), getClass('grid', 'container')]">

  <label *ngIf="!isCheckbox && hasLabel"
         [id]="'label_' + model.id"
         [for]="id"
         [innerHTML]="(model.required && model.label) ? (model.label | translate) + ' *' : (model.label | translate)"
         [ngClass]="[getClass('element', 'label'), getClass('grid', 'label')]"></label>
  <div class="d-flex">
    <div class="flex-grow-1">
      <ng-container *ngTemplateOutlet="startTemplate?.templateRef; context: { $implicit: model };"></ng-container>
      <!-- Should be *ngIf instead of class d-none, but that breaks the #componentViewContainer reference-->
      <div [ngClass]="{'form-row': model.hasLanguages || isRelationship || model.hasSecurityToggle,
                     'd-none': this.metadataService.isVirtual(value) && (model.hasSelectableMetadata || context?.index > 0)}">
        <div [ngClass]="getClass('grid', 'control')">
          <div>
            <ng-container #componentViewContainer></ng-container>
          </div>
          <div class="d-flex flex-column w-100">
            <small
              *ngIf="hasHint &&
           (formBuilderService.hasArrayGroupValue(model) ||
            (
              (!model.repeatable
                && (!(model?.isModelOfNotRepeatableGroup) || model?.isModelOfNotRepeatableGroup && context?.index === context?.context?.groups?.length - 1)
              )
             && (isRelationship === false || value?.value === null)
           )
           || (model.repeatable === true && context?.index === context?.context?.groups?.length - 1 )
           || hasHintAndIsRepeatable
           || (model.type==='TAG')) && (!showErrorMessages || errorMessages.length === 0)"
              class="text-muted ds-hint" [innerHTML]="model.hint | translate" [ngClass]="getClass('element', 'hint')"
            ></small>
            <small class="text-muted mt-2" *ngIf="formBuilderService.isScrollableDropdown(model) && enabledDropdownHints[model?.metadataFields[0]] && (model.value?.value) !== null">
              <i class="fas fa-info-circle mr-2"></i>{{'submission.dropdown.hint.' + model.value?.value | translate}}
            </small>
          </div>
          <!-- In case of repeatable fields show empty space for all elements except the first -->
          <!-- In case of not repeatable field with multiple values show empty space for all elements except the last -->
          <div *ngIf="(context?.index !== null && (!showErrorMessages || errorMessages.length === 0)) || (!hasHint && !showErrorMessages) ||
                  (!model.hideErrorMessages && showErrorMessages && !(!(model?.isModelOfNotRepeatableGroup) || model?.isModelOfNotRepeatableGroup && context?.index === context?.context?.groups?.length - 1)) && isNotRequiredGroupAndEmpty()"
               class="clearfix w-100 mb-2"></div>

          <!-- In case of not repeatable field with multiple values show error message for the last element only -->
          <div
            *ngIf="!model.hideErrorMessages && showErrorMessages && (!(model?.isModelOfNotRepeatableGroup) || model?.isModelOfNotRepeatableGroup && context?.index === context?.context?.groups?.length - 1) && isNotRequiredGroupAndEmpty()"
            [id]="id + '_errors'"
            [ngClass]="[getClass('element', 'errors'), getClass('grid', 'errors')]">
            <small *ngFor="let message of errorMessages"
                   class="invalid-feedback d-block">{{ message | translate: model.validators }}</small>
          </div>
        </div>
        <div *ngIf="model.languageCodes && model.languageCodes.length > 0" class="col-xs-2">
          <select
            #language="ngModel"
            [disabled]="model.readOnly"
            [(ngModel)]="model.language"
            class="form-control"
            (blur)="onBlur($event)"
            (change)="onChangeLanguage($event)"
            [ngModelOptions]="{standalone: true}"
            required>
            <option *ngFor="let lang of model.languageCodes" [value]="lang.code">{{lang.display}}</option>
          </select>
        </div>
        <div *ngIf="model.hasSecurityToggle" class="col-xs-2" [class.date-field-security]="model.type === 'DATE'">
          <ds-edit-metadata-security *ngIf="model.toggleSecurityVisibility"
                                     [readOnly]="model.readOnly"
                                     [securityConfigLevel]="model.securityConfigLevel"
                                     [securityLevel]="securityLevel"
                                     (changeSecurityLevel)="addSecurityLevelToMetadata($event)">
          </ds-edit-metadata-security>
        </div>
        <div *ngIf="isRelationship" class="col-auto text-center">
          <button class="btn btn-secondary"
                  type="button"
                  ngbTooltip="{{'form.lookup-help' | translate}}"
                  [attr.aria-label]="'form.lookup-help' | translate"
                  placement="top"
                  data-test="lookup-button"
                  (click)="openLookup(); $event.stopPropagation();"><i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <ng-container
      *ngTemplateOutlet="endTemplate?.templateRef; context: { $implicit: model, model: model }"></ng-container>
    <ng-container *ngIf="this.metadataService.isVirtual(value)">
      <ds-existing-metadata-list-element
        *ngIf="model.hasSelectableMetadata"
        [reoRel]="relationshipValue$ | async"
        [submissionItem]="item$ | async"
        [listId]="listId"
        [metadataFields]="model.metadataFields"
        [submissionId]="model.submissionId"
        [relationshipOptions]="model.relationship"
        (remove)="onRemove()">
      </ds-existing-metadata-list-element>
      <ds-existing-relation-list-element
        *ngIf="!model.hasSelectableMetadata"
        [ngClass]="{'d-block pb-2 pt-2': !context?.index}"
        [reoRel]="relationshipValue$ | async"
        [submissionItem]="item$ | async"
        [listId]="listId"
        [metadataFields]="model.metadataFields"
        [submissionId]="model.submissionId"
        [relationshipOptions]="model.relationship">
      </ds-existing-relation-list-element>
      <small
        *ngIf="hasHint && (model.repeatable === false || context?.index === context?.context?.groups?.length - 1) && (!showErrorMessages || errorMessages.length === 0)"
        class="text-muted ds-hint" [innerHTML]="model.hint | translate" [ngClass]="getClass('element', 'hint')"></small>
      <div class="clearfix w-100 mb-2"></div>
    </ng-container>
    <ng-content></ng-content>
  </div>

</div>
